import instance from '@/utils/instance';

//获取书单
export function getMemberGetBookList(data) {
	return instance({
		url: `/webL_api/consumer/member/getBookList/${data}`,
		method: 'get'
	});
}

//移除书单
export function deleteMemberRemoveBookList(data) {
	return instance({
		url: `/webL_api/consumer/member/removeBookList/${data}`,
		method: 'delete'
	});
}

//更新书单
export function postMemberUpdateBookList(data) {
	return instance({
		url: `/webL_api/consumer/member/updateBookList`,
		method: 'post',
		data
	});
}

//新增书单
export function postMemberAddBookList(data) {
	return instance({
		url: `/webL_api/consumer/member/addBookList`,
		method: 'post',
		data
	});
}
